




















import mixins from 'vue-typed-mixins';
export default mixins().extend({
  computed: {
    attrs(): any {
      return {
        ...this.$attrs,
      };
    },

    listeners(): any {
      return {
        ...this.$listeners,
      };
    },
  },

  data(): {
    displayPassword: boolean;
  } {
    return {
      displayPassword: false,
    };
  },
});
